<div class="gel">
  <!-- Initial loader -->
  <div *ngIf="!events.length && isLoading" class="gel__loader d-flex align-items-center justify-content-center">
    <mat-spinner diameter="32" mode="indeterminate"></mat-spinner>
  </div>

  <!-- Empty state -->
  <div
    *ngIf="!events.length && !isLoading"
    class="gel__empty d-flex flex-column align-items-center justify-content-center gap-2"
  >
    <mat-icon class="gel__empty-icon">timeline</mat-icon>
    <span class="gel__empty-text">No team activity yet</span>
  </div>

  <!-- Feed -->
  <div
    class="gel__feed"
    [class.pb-4]="lastKey"
    [@listFadeInOut]="events.length"
    infinite-scroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="150"
    (scrolled)="onScrollDown()"
  >
    <div
      *ngFor="let event of events; last as isLast"
      class="gel__item"
      [class.gel__item--last]="isLast"
      [ngClass]="getEventClass(event.type)"
    >
      <!-- Left accent + icon -->
      <div class="gel__item-icon-col">
        <div class="gel__item-icon-wrap">
          <mat-icon class="gel__item-icon">{{ getEventIcon(event.type) }}</mat-icon>
        </div>
        <div class="gel__item-line" *ngIf="!isLast"></div>
      </div>

      <!-- Content -->
      <div class="gel__item-body flex-grow-1 min-w-0">
        <!-- Avatars + message -->
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <!-- Single avatar -->
          <ng-container [ngSwitch]="event.type">
            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.MEMBER_ADD_ACHIEVEMENT">
              <div class="gel__avatar">
                <app-s3-image
                  [isRounded]="true"
                  [image]="asAny(event).data?.member?.avatarUrl"
                  [avatarName]="asAny(event).data?.member?.username"
                ></app-s3-image>
              </div>
              <span
                class="gel__message"
                [innerHTML]="
                  'GAMIFICATION_EVENTS_LIST.TEAM_MEMBER_WAS_AWARDED'
                    | translate
                      : {
                          username: asAny(event).data?.member?.userData?.nickname || asAny(event).data?.member?.username
                        }
                "
              ></span>
              <div
                class="gel__achievement-icon"
                *ngIf="asAny(event).data?.achievement?.icon"
                [matTooltip]="asAny(event).data?.description"
              >
                <app-s3-image [image]="asAny(event).data?.achievement?.icon"></app-s3-image>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.MEMBER_LEVEL_UP">
              <div class="gel__avatar">
                <app-s3-image
                  [isRounded]="true"
                  [image]="asAny(event).data?.member?.avatarUrl"
                  [avatarName]="asAny(event).data?.member?.username"
                ></app-s3-image>
              </div>
              <span
                class="gel__message"
                [innerHTML]="
                  'GAMIFICATION_EVENTS_LIST.TEAM_MEMBER_HAS_REACHED_LEVEL'
                    | translate
                      : {
                          username:
                            asAny(event).data?.member?.userData?.nickname || asAny(event).data?.member?.username,
                          name: asAny(event).data?.level?.name
                        }
                "
              ></span>
              <div
                class="gel__achievement-icon"
                *ngIf="asAny(event).data?.level?.icon"
                [matTooltip]="asAny(event).data?.level?.name"
              >
                <app-s3-image [image]="asAny(event).data?.level?.icon"></app-s3-image>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.NEW_MEMBER">
              <div class="gel__avatar">
                <app-s3-image
                  [isRounded]="true"
                  [image]="asAny(event).data?.member?.avatarUrl"
                  [avatarName]="asAny(event).data?.member?.username"
                ></app-s3-image>
              </div>
              <span
                class="gel__message"
                [innerHTML]="
                  'GAMIFICATION_EVENTS_LIST.JOINED_TO_TEAM'
                    | translate
                      : {
                          username: asAny(event).data?.member?.userData?.nickname || asAny(event).data?.member?.username
                        }
                "
              ></span>
            </ng-container>

            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.LEFT_MEMBER">
              <div class="gel__avatar">
                <app-s3-image
                  [isRounded]="true"
                  [image]="asAny(event).data?.member?.avatarUrl"
                  [avatarName]="asAny(event).data?.member?.username"
                ></app-s3-image>
              </div>
              <span
                class="gel__message"
                [innerHTML]="
                  'GAMIFICATION_EVENTS_LIST.HAS_LEFT_TEAM'
                    | translate
                      : {
                          username: asAny(event).data?.member?.userData?.nickname || asAny(event).data?.member?.username
                        }
                "
              ></span>
            </ng-container>

            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.LEVEL_UP">
              <span
                class="gel__message"
                [innerHTML]="
                  'GAMIFICATION_EVENTS_LIST.TEAM_HAS_REACHED_LEVEL'
                    | translate: { name: asAny(event).data?.level?.name }
                "
              ></span>
              <div
                class="gel__achievement-icon"
                *ngIf="asAny(event).data?.level?.icon"
                [matTooltip]="asAny(event).data?.level?.name"
              >
                <app-s3-image [image]="asAny(event).data?.level?.icon"></app-s3-image>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.ADD_ACHIEVEMENT">
              <span class="gel__message">{{ 'GAMIFICATION_EVENTS_LIST.TEAM_WAS_WARDED' | translate }}</span>
              <div
                class="gel__achievement-icon"
                *ngIf="asAny(event).data?.achievement?.icon"
                [matTooltip]="asAny(event).data?.description"
              >
                <app-s3-image [image]="asAny(event).data?.achievement?.icon"></app-s3-image>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.NEW_CHALLENGE">
              <div class="gel__avatar-stack">
                <div class="gel__avatar gel__avatar--sm">
                  <app-s3-image
                    [isRounded]="true"
                    [image]="asAny(event).data?.initiator?.avatarUrl"
                    [avatarName]="asAny(event).data?.initiator?.username"
                  ></app-s3-image>
                </div>
                <div class="gel__avatar gel__avatar--sm gel__avatar--offset">
                  <app-s3-image
                    [isRounded]="true"
                    [image]="asAny(event).data?.opponent?.avatarUrl"
                    [avatarName]="asAny(event).data?.opponent?.username"
                  ></app-s3-image>
                </div>
              </div>
              <span
                class="gel__message"
                [innerHTML]="
                  'GAMIFICATION_EVENTS_LIST.NEW_CHALLENGED'
                    | translate
                      : {
                          initiator:
                            asAny(event).data?.initiator?.userData?.nickname || asAny(event).data?.initiator?.username,
                          opponent:
                            asAny(event).data?.opponent?.userData?.nickname || asAny(event).data?.opponent?.username
                        }
                "
              ></span>
            </ng-container>

            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.WON_CHALLENGE">
              <div class="gel__avatar-stack">
                <div class="gel__avatar gel__avatar--sm">
                  <app-s3-image
                    [isRounded]="true"
                    [image]="asAny(event).data?.winner?.avatarUrl"
                    [avatarName]="asAny(event).data?.winner?.username"
                  ></app-s3-image>
                </div>
                <div class="gel__avatar gel__avatar--sm gel__avatar--offset">
                  <app-s3-image
                    [isRounded]="true"
                    [image]="asAny(event).data?.opponent?.avatarUrl"
                    [avatarName]="asAny(event).data?.opponent?.username"
                  ></app-s3-image>
                </div>
              </div>
              <span
                class="gel__message"
                [innerHTML]="
                  'GAMIFICATION_EVENTS_LIST.WON_CHALLENGE'
                    | translate
                      : {
                          winner: asAny(event).data?.winner?.userData?.nickname || asAny(event).data?.winner?.username,
                          opponent:
                            asAny(event).data?.opponent?.userData?.nickname || asAny(event).data?.opponent?.username
                        }
                "
              ></span>
            </ng-container>

            <ng-container *ngSwitchCase="EVENT_TYPE.TEAM.DRAW_CHALLENGE">
              <div class="gel__avatar-stack">
                <div class="gel__avatar gel__avatar--sm">
                  <app-s3-image
                    [isRounded]="true"
                    [image]="asAny(event).data?.initiator?.avatarUrl"
                    [avatarName]="asAny(event).data?.initiator?.username"
                  ></app-s3-image>
                </div>
                <div class="gel__avatar gel__avatar--sm gel__avatar--offset">
                  <app-s3-image
                    [isRounded]="true"
                    [image]="asAny(event).data?.opponent?.avatarUrl"
                    [avatarName]="asAny(event).data?.opponent?.username"
                  ></app-s3-image>
                </div>
              </div>
              <span
                class="gel__message"
                [innerHTML]="
                  'GAMIFICATION_EVENTS_LIST.DRAW_CHALLENGE'
                    | translate
                      : {
                          initiator:
                            asAny(event).data?.initiator?.userData?.nickname || asAny(event).data?.initiator?.username,
                          opponent:
                            asAny(event).data?.opponent?.userData?.nickname || asAny(event).data?.opponent?.username
                        }
                "
              ></span>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <span class="gel__message gel__message--muted">{{
                'GAMIFICATION_EVENTS_LIST.TYPE_IS_NOT_SUPPORTED' | translate: { type: event.type }
              }}</span>
            </ng-container>
          </ng-container>
        </div>

        <!-- Date -->
        <div class="gel__date">{{ asAny(event).id.split('_')[0] | date: 'd MMM yyyy' }}</div>
      </div>
    </div>
    <!-- /.gel__item -->
  </div>
  <!-- /.gel__feed -->

  <!-- Load more indicator -->
  <div *ngIf="events.length && isLoading" class="gel__load-more d-flex align-items-center justify-content-center gap-2">
    <span class="gel__load-more-dot"></span>
    <span class="gel__load-more-label">{{ 'GENERAL.LOADING' | translate }}…</span>
  </div>
</div>
